<template>
  <div id="kt_footer" class="footer py-2 py-lg-0 my-10 d-flex flex-lg-column">
    <div
      class="d-flex flex-column align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="text-dark order-2 order-md-1">
        <a
          href="https://damaco.dev"
          target="_blank"
          class="text-dark-75 text-hover-primary"
        >
          {{ getYear() }} © Build with ♥️ by damaco.dev
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getYear } from "@/core/utils";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
  },
  methods: {
    getYear,
  },
};
</script>
